var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "172px",
    height: "48px",
    viewBox: "0 0 172 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B66A44B2-866E-4CF0-B235-0337F4198CFB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-873.000000, -5872.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(304.000000, 5802.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(569.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    fill: "#15AAC5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    x: 0,
    y: 0,
    width: 172,
    height: 48,
    rx: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(29.000000, 11.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Download",
    fontFamily: "SourceSansPro-Semibold, Source Sans Pro",
    fontSize: 18,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 35,
    y: 20
  }, "Download")), /*#__PURE__*/React.createElement("g", {
    id: "playstore",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.521881838,0.957504285 C0.203501094,1.36434939 0.0262582057,1.86482237 0.0262582057,2.40040587 L0.0262582057,23.5991974 C0.0262582057,24.0966949 0.179704595,24.5640411 0.456851764,24.954422 L12.3854623,12.923233 L0.521881838,0.957504285 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4776395,11.821518 L17.3474426,7.91850282 L3.74466633,0.324523926 C3.15426696,-0.00515744531 2.47688728,-0.0833129883 1.84484408,0.0884704844 L13.4776395,11.821518 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4776395,14.0247498 L1.72729759,25.8762207 C1.98064826,25.9585419 2.24282001,26 2.50519694,26 C2.93086708,26 3.35674235,25.8916931 3.74466633,25.6750793 L17.4452954,18.0263519 L13.4776395,14.0247498 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7305799,10.9239197 L18.7536925,8.70362853 L14.5700219,12.9230347 L18.8513403,17.2414246 L22.7305799,15.0756836 C23.5068381,14.6424561 23.9702544,13.8662567 23.9702544,12.9998016 C23.9702544,12.1331482 23.5068381,11.3571472 22.7305799,10.9239197 Z",
    id: "Path"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButton);
export default __webpack_public_path__ + "static/media/DownloadButton.8dde2ae031a601d3192c6fc9abc21240.svg";
export { ForwardRef as ReactComponent };